'use strict';

import _ from 'lodash';
import React from 'react';
import Analytics from '../common/analytics';

class Live_Stream extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let liveStream = this.props.conference.current.live_stream && this.props.conference.current.live_stream.live_stream_embed ? this.props.conference.current.live_stream.live_stream_embed : null;
    let upNextImage = this.props.conference.current.live_stream && this.props.conference.current.live_stream.up_next_speaker_img ? '/' + this.props.conference.current.live_stream.up_next_speaker_img : null;
    let nowSpeaking = this.props.conference.current.live_stream && this.props.conference.current.live_stream.now_speaking ? this.props.conference.current.live_stream.now_speaking : null;
    let nextLiveStream = this.props.conference.current.live_stream && this.props.conference.current.live_stream.next_live_stream ? this.props.conference.current.live_stream.next_live_stream : null;
    let nextLiveStreamHeader = '<h2>Next Live Stream</h2>';
    let gfor = (this.props.conference.current.conference_id == 'global-future-of-retirement') ? 'GFOR ' : null;
    let display = this.props.conference.current.live_stream && this.props.conference.current.live_stream.livestream_promo ? this.props.conference.current.live_stream.livestream_promo : null;
    let nowSpeakingHeader = (display == 'live_stream_embed') ? '<h2>Now Speaking</h2>' : '<h2>Up Next</h2>';

    return <div className="multimedia">
      <section className="section">
        <div className="wrap-one clearfix">
          <div className="title">{gfor}Live Stream</div>
        </div>
      </section>
      {(!display || display == 'none' || display == '') ? null :
        <div>
          <div id="featured-photo-video" className="secondary-section media">
            <div className="wrap-one">
              <div className="bio-wrap clearfix">
                <div className="video">
                  <div className="media-wrap">
                    {(display == 'live_stream_embed') ?
                      <div id="featured-video-container" className="embed-responsive embed-responsive-16by9"
                        dangerouslySetInnerHTML={{ __html: liveStream }}>
                      </div> : null}
                    {(display == 'up_next_speaker_img') ?
                      <div id="featured-video-container" className="embed-responsive embed-responsive-16by9">
                        <img src={upNextImage}></img>
                      </div> : null
                    }
                    {(!nowSpeaking || nowSpeaking == '') ? null :
                      <div>
                        <div id="now-speaking-header"
                          dangerouslySetInnerHTML={{ __html: nowSpeakingHeader }}>
                        </div>
                        <div id="now-speaking-div"
                          dangerouslySetInnerHTML={{ __html: nowSpeaking }}>
                        </div>
                      </div>
                    }
                    {(!nextLiveStream || nextLiveStream == '') ? null :
                      <div>
                        <div id="next-live-stream-header"
                          dangerouslySetInnerHTML={{ __html: nextLiveStreamHeader }}>
                        </div>
                        <div id="next-live-stream-div"
                          dangerouslySetInnerHTML={{ __html: nextLiveStream }}>
                        </div>
                      </div>
                    }
                    {!gfor ? null :
                      <div id="gforVideoLink">
                        <p>If you missed any of the GFOR live stream events, please go to <a href='/conference/global-future-of-retirement/2016/multimedia'>www.pionline.com/GFOR</a>
                        </p>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <Analytics view="live_stream" {...this.props} />
    </div>
  }
}

export default Live_Stream;
